import keyCodes from '../../../../../../editJournal/constants/keyCodes';
import renderDict from './renderDict';
import createNewBulletBellow from '../../../../../../editJournal/slateUtilities/plugins/createNewBulletBellow';
import findBulletLevel from '../../../../../../editJournal/slateUtilities/plugins/findBulletLevel';
import handleBulletShifting from '../../../../../../editJournal/slateUtilities/plugins/handleBulletShifting';
import handleInsertRole from './insertRole';

export default (params) => {
  const { event, editor, nodeType } = params;

  const {
    value: { focusBlock, document },
  } = editor;

  if (event.which === keyCodes.ENTER) {
    const { key: focusBlockKey, type: focusBlockType } = focusBlock;
    const parent = document.getParent(focusBlockKey);
    const { type: parentType } = parent;
    const levelOfBullet = findBulletLevel(editor);

    if (event.shiftKey) {
      if (
        renderDict[parentType] === 'organization_role_editable_div' ||
        renderDict[parentType] === 'list_item'
      ) {
        const parentLI = document.getParent(editor.value.focusBlock.key);
        const parentUL = document.getParent(parentLI.key);
        const indexOfParentListItem = parentUL.nodes
          .toArray()
          .indexOf(parentLI);
        if (
          editor.value.focusBlock.text === '' &&
          indexOfParentListItem === 0
        ) {
          if (levelOfBullet === 0) handleBulletShifting(editor, true);
          else editor.deleteBackward().insertText('\n');
        } else editor.insertText('\n');
        return true;
      }

      event.preventDefault();
      return true;
    }

    if (renderDict[parentType] === 'list_item') {
      if (editor.value.focusBlock.text === '') {
        handleBulletShifting(
          editor,
          true,
          editor.value.focusBlock,
          null,
          null,
          null,
          editor.value.document,
        );
        return true;
      }
      createNewBulletBellow(editor);
      return true;
    }

    if (renderDict[focusBlockType] === 'array_item') {
      const { statusBarRef, props } = params;
      handleInsertRole(event, editor, focusBlock, statusBarRef, props);
      return true;
    }

    if (renderDict[parentType] !== 'organization_role_editable_div') {
      return true;
    }
    if (nodeType === 'letter_body') {
      editor.splitBlock();
      return true;
    }
  }

  return false;
};
